import { render, staticRenderFns } from "./PLItems.vue?vue&type=template&id=92b0abae&"
import script from "./PLItems.vue?vue&type=script&lang=js&"
export * from "./PLItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports